export default [
  {
    path: '/send_invitation',
    name: 'send_invitation',
    component: () => import('@/views/modules/admins/SendInvitations.vue'),
  },
]
